/**
 * aws-amplify npm package uses Axios underneath API module
 * The following interceptor add Axios headers to every API call to AWS
 *
 */

import axios from 'axios'

export function addAuthorizationHeader({ token }) {
  axios.interceptors.request.use(function (config) {
    config.headers.Authorization = token

    return config
  })
}

axios.interceptors.response.use(function (response) {
  if (response.status === 403) {
    throw new Error('Network Error')
  }
  return response
})
